// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

// We have deprecated emotion. Please use compiled instead
// eslint-disable-next-line no-restricted-imports

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/standard-button';
import { N0, N80 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const StyledActionButton = styled(Button)`
	&& {
		color: ${({ isSelected }) =>
			isSelected ? token('color.text.inverse', N0) : token('color.text.subtlest', N80)} !important;
		min-width: 32px;
	}
`;

type ActionButtonWrapperProps = {
	forceShow?: boolean;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const ActionButtonWrapper = styled.div<ActionButtonWrapperProps>`
	transition: ease-in 150ms;
	opacity: ${({ forceShow }) => (forceShow ? '1' : 'var(--show-action)')};
`;
